export default "__VITE_ASSET__1be8a820__"